import { NodeShape } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { JointCommentShape } from './Shape/JointCommentShape';
import { BEComment } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComment';
import { Diagram } from './Diagram';
import { DiagramShape } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/DiagramShape';
import { JointEntityShape } from './Shape/JointEntityShape';
import { JointBusinessLogicShape } from './Shape/JointBusinessLogicShape';
import { BEEntity } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEEntity';
import { JointGenerationLink } from './Link/JointGenerationLink';
import { JointImplementLink } from './Link/JointImplementLink';
import { MDAConstant } from '../Base/MDAConstant';
import { JointInterfaceShape } from './Shape/JointInterfaceShape';
import { BEInterface } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEInterface';
import { CommentContextMenu } from './ContextMenu/CommentContextMenu';
import { EntityContextMenu } from './ContextMenu/EntityContextMenu';
import { InterfaceContextMenu } from './ContextMenu/InterfaceContextMenu';
import { ShapeService } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/ShapeService';
import { LineShape } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/LineShape';
import { EntityGeneration } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EntityGeneration';
import { InterfaceGeneration } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/InterfaceGeneration';
import { Implement } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Implement';
import { Association } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Association';
import { JointAssociationLink } from './Link/JointAssociationLink';
import { BEEnum } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEEnum';
import { JointEnumShape } from './Shape/JointEnumShape';
import { EnumContextMenu } from './ContextMenu/EnumContextMenu';
import { ComponentContextMenu } from './ContextMenu/ComponentContextMenu';
import { Composition } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Composition';
import { JointCompositionLink } from './Link/JointCompositionLink';
import { Aggregation } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Aggregation';
import { JointAggregationLink } from './Link/JointAggregationLink';
import { CrossAssociation } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/CrossAssociation';
import { JointCrossLink } from './Link/JointCrossLink';
import { DependencyAssociation } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/DependencyAssociation';
import { JointDependencyAssociationLink } from './Link/JointDependencyAssociationLink';
import { BEBusinessLogic } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEBusinessLogic';
import { BusinessLogicContextMenu } from './ContextMenu/BusinessLogicContextMenu';
import { JointDTOShape } from './Shape/JointDTOShape';
import { DTOContextMenu } from './ContextMenu/DTOContextMenu';
import { BEDTO } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEDTO';
import { JointServiceShape } from './Shape/JointServiceShape';
import { ServiceContextMenu } from './ContextMenu/ServiceContextMenu';
import { BEService } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEService';
import { JointConstantShape } from './Shape/JointConstantShape';
import { ConstantContextMenu } from './ContextMenu/ConstantContextMenu';
import { BEConstant } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEConstant';
import { MDExtendService } from '../../MD/MDExtendService';
import { BEComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { MenuSet } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/MenuSet';
import { JointMenuSetShape } from './Shape/JointMenuSetShape';
import { MenuSetContextMenu } from './ContextMenu/MenuSetContextMenu';
import { APPComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/APPComponent';
import { MenuContain } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/MenuContain';
import { JointMenuContainLink } from './Link/JointMenuContainLink';
import { JointConfigGroupShape } from './Shape/JointConfigGroupShape';
import { ConfigGroup } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/ConfigGroup';
import { ConfigGroupContextMenu } from './ContextMenu/ConfigGroupContextMenu';
import { BaseComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { JointExternalServiceShape } from './Shape/JointExternalServiceShape';
import { ExternalServiceContextMenu } from './ContextMenu/ExternalServiceContextMenu';
import { BEExternalService } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEExternalService';
import { JointDistributedTransactionShape } from './Shape/JointDistributedTransactionShape';
import { DistributedTransactionContextMenu } from './ContextMenu/DistributedTransactionContextMenu';
import { BEDistributedTransaction } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEDistributedTransaction';
import { MDRepository } from '../../MD/MDRepository';
import { MDShapeRepository } from '../BaseShape/MDShapeRepository';
import { JointValueObjectShape } from './Shape/JointValueObjectShape';
import { ValueObjectContextMenu } from './ContextMenu/ValueObjectContextMenu';
import { BEValueObject } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEValueObject';
import { MDShape } from '../BaseShape/MDShape';
import { BEAttribute } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEAttribute';
import { EntityMethod } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EntityMethod';
import { BLParameter } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BLParameter';
import { ConfigItem } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/ConfigItem';
import { ConstantItem } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/ConstantItem';
import { DTAttribute } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/DTAttribute';
import { DTOAttribute } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/DTOAttribute';
import { EnumItem } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumItem';
import { ESParameter } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/ESParameter';
import { InterfaceMethod } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/InterfaceMethod';
import { InterfaceAttribute } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/InterfaceAttribute';
import { MenuItem } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/MenuItem';
import { BEServiceAction } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEServiceAction';
import { ValueObjectAttribute } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/ValueObjectAttribute';
import { ValueObjectMethod } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/ValueObjectMethod';
import { RelationshipLink } from '../BaseShape/RelationshipLink';
import { MDBaseShape } from '../BaseShape/MDBaseShape';
import { JointMethodShape } from './Shape/JointMethodShape';
import { MethodParameter } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/MethodParameter';
import { MethodContextMenu } from './ContextMenu/MethodContextMenu';
import { APPComment } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/APPComment';
import { ProductComment } from '../../../../../../api/com/MetaPattern/MDA/MD/ProductModel/ProductComment';
import { ProductComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/ProductModel/ProductComponent';
import { ProductAPP } from '../../../../../../api/com/MetaPattern/MDA/MD/ProductModel/ProductAPP';
import { JointProductAPPShape } from './Shape/JointProductAPPShape';
import { ProductAPPContextMenu } from './ContextMenu/ProductAPPContextMenu';
import { JointReferenceEntityShape } from './Shape/JointReferenceEntityShape';
import { BEReferenceEntity } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEReferenceEntity';
import { ReferenceEntityContextMenu } from './ContextMenu/ReferenceEntityContextMenu';

/* 封装了整合Joint的图形转化器，用于构建图形，将Joint、图形、元数据进行解耦 */
export class JointShapeRepository {
  /**
   * 创建元数据图形
   * @param type 类型，使用MDAConstant.Type中定义的常量
   * @param diagram 要创建图形的图表
   * @param startX 创建图形起点的X坐标
   * @param startY 创建图形起点的Y坐标
   */
  static createTypeShape(type: string, diagram: Diagram, startX: number, startY: number): any {
    let shape = null;
    switch (type) {
      // 以下是BE组件的类型
      case MDAConstant.Type.ADD_BECOMMENT:
        shape = this.createBECommentShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_ENTITY:
        shape = this.createEntityShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_INTERFACE:
        shape = this.createInterfaceShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_ENUM:
        shape = this.createEnumShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_BUSINESSLOGIC:
        shape = this.createBusinessLogicShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_DTO:
        shape = this.createDTOShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_VALUEOBJECT:
        shape = this.createValueObjectShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_SERVICE:
        shape = this.createServiceShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_CONSTANT:
        shape = this.createConstantShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_REFERENCEENTITY:
        shape = this.createReferenceEntityShape(diagram, null, null, startX, startY);
        break;
      // 以下是APP组件的类型
      case MDAConstant.Type.ADD_APPCOMMENT:
        shape = this.createAPPCommentShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_MENUSET:
        shape = this.createMenuSetShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_CONFIGGROUP:
        shape = this.createConfigGroupShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_EXTERNALSERVICE:
        shape = this.createExternalServiceShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_DISTRIBUTEDTRANSACTION:
        shape = this.createDistributedTransactionShape(diagram, null, null, startX, startY);
        break;
      // 以下是Product组件的类型
      case MDAConstant.Type.ADD_PRODUCTCOMMENT:
        shape = this.createProductCommentShape(diagram, null, null, startX, startY);
        break;
      case MDAConstant.Type.ADD_PRODUCTAPP:
        shape = this.createProductAPPShape(diagram, null, null, startX, startY);
        break;
      default:
        break;
    }
    if (shape !== null) {
      diagram.cells.push(shape);
    }
    return shape;
  }

  /**
   * 创建右键菜单
   * @param cell 右键点击的图形model
   * @param evtTarget 引发右键事件的目标
   * @param data 带入的额外数据
   */
  static createContextMenu(cell: any, evtTarget: any, data?: any): any {
    let menu = null;
    if (cell instanceof JointEntityShape) {
      menu = new EntityContextMenu(cell, evtTarget);
    } else if (cell instanceof JointCommentShape) {
      menu = new CommentContextMenu(cell, evtTarget);
    } else if (cell instanceof JointInterfaceShape) {
      menu = new InterfaceContextMenu(cell, evtTarget);
    } else if (cell instanceof JointEnumShape) {
      menu = new EnumContextMenu(cell, evtTarget);
    } else if (cell instanceof JointBusinessLogicShape) {
      menu = new BusinessLogicContextMenu(cell, evtTarget);
    } else if (cell instanceof JointDTOShape) {
      menu = new DTOContextMenu(cell, evtTarget);
    } else if (cell instanceof JointValueObjectShape) {
      menu = new ValueObjectContextMenu(cell, evtTarget);
    } else if (cell instanceof JointServiceShape) {
      menu = new ServiceContextMenu(cell, evtTarget);
    } else if (cell instanceof JointConstantShape) {
      menu = new ConstantContextMenu(cell, evtTarget);
    } else if (cell instanceof JointReferenceEntityShape) {
      menu = new ReferenceEntityContextMenu(cell, evtTarget);
    } else if (cell instanceof JointMethodShape) {
      menu = new MethodContextMenu(cell, evtTarget);
    } else if (cell instanceof JointMenuSetShape) {
      menu = new MenuSetContextMenu(cell, evtTarget);
    } else if (cell instanceof JointConfigGroupShape) {
      menu = new ConfigGroupContextMenu(cell, evtTarget);
    } else if (cell instanceof JointExternalServiceShape) {
      menu = new ExternalServiceContextMenu(cell, evtTarget);
    } else if (cell instanceof JointDistributedTransactionShape) {
      menu = new DistributedTransactionContextMenu(cell, evtTarget);
    } else if (cell instanceof JointProductAPPShape) {
      menu = new ProductAPPContextMenu(cell, evtTarget);
    } else {
      menu = new ComponentContextMenu(cell, evtTarget, data);
    }
    return menu;
  }

  /**
   * 创建关系线
   * @param linkType 关系线的类型，使用MDAConstant里面的常量定义
   * @param source 线的起点
   * @param target 线的终点
   */
  static createLink(linkType: string, diagram: Diagram, source: any, target: any): RelationshipLink {
    let link = null;
    switch (linkType) {
      case MDAConstant.Link.ADD_GENERALIZATION:
        link = this.createGenerationLink(diagram, null, null, null, source, target);
        break;
      case MDAConstant.Link.ADD_IMPLEMENT:
        link = this.createImplementLink(diagram, null, null, source, target);
        break;
      case MDAConstant.Link.ADD_ASSOCIATION:
        link = this.createAssociationLink(diagram, null, null, source, target);
        break;
      case MDAConstant.Link.ADD_COMPOSITION:
        link = this.createCompositionLink(diagram, null, null, source, target);
        break;
      case MDAConstant.Link.ADD_AGGREGATION:
        link = this.createAggregationLink(diagram, null, null, source, target);
        break;
      case MDAConstant.Link.ADD_CROSS:
        link = this.createCrossLink(diagram, null, null, source, target);
        break;
      case MDAConstant.Link.ADD_DEPENDENCY:
        link = this.createDependencyLink(diagram, null, null, source, target);
        break;
      case MDAConstant.Link.ADD_MENUCONTAIN:
        link = this.createMenuContainLink(diagram, null, null, source, target);
        break;
      default:
        link = null;
        break;
    }
    return link;
  }

  /**
   * 图形完整拷贝，包含其内部的元数据及图形元数据
   * @param diagram 图表
   * @param source 源图形
   * @param target 目标图形，如果不存在则创建
   */
  static copyFullShape(diagram: Diagram, source: MDShape, target: MDShape) {
    if (source instanceof MDBaseShape) {
      if (source instanceof JointCommentShape) {
        this.copyFullCommentShape(diagram, source, target as JointCommentShape);
      } else if (source instanceof JointEntityShape) {
        this.copyFullEntityShape(diagram, source, target as JointEntityShape);
      } else if (source instanceof JointBusinessLogicShape) {
        this.copyFullBusinessLogicShape(diagram, source, target as JointBusinessLogicShape);
      } else if (source instanceof JointServiceShape) {
        this.copyFullServiceShape(diagram, source, target as JointServiceShape);
      } else if (source instanceof JointDTOShape) {
        this.copyFullDTOShape(diagram, source, target as JointDTOShape);
      } else if (source instanceof JointEnumShape) {
        this.copyFullEnumShape(diagram, source, target as JointEnumShape);
      } else if (source instanceof JointConstantShape) {
        this.copyFullConstantShape(diagram, source, target as JointConstantShape);
      } else if (source instanceof JointReferenceEntityShape) {
        this.copyFullReferenceEntityShape(diagram, source, target as JointReferenceEntityShape);
      } else if (source instanceof JointInterfaceShape) {
        this.copyFullInterfaceShape(diagram, source, target as JointInterfaceShape);
      } else if (source instanceof JointValueObjectShape) {
        this.copyFullValueObjectShape(diagram, source, target as JointValueObjectShape);
      } else if (source instanceof JointDistributedTransactionShape) {
        this.copyFullDistributedTransactionShape(diagram, source, target as JointDistributedTransactionShape);
      } else if (source instanceof JointExternalServiceShape) {
        this.copyFullExternalServiceShape(diagram, source, target as JointExternalServiceShape);
      } else if (source instanceof JointMenuSetShape) {
        this.copyFullMenuSetShape(diagram, source, target as JointMenuSetShape);
      } else if (source instanceof JointConfigGroupShape) {
        this.copyFullConfigGroupShape(diagram, source, target as JointConfigGroupShape);
      } else if (source instanceof JointProductAPPShape) {
        this.copyFullProductAPPShape(diagram, source, target as JointProductAPPShape);
      }
    } else if (source instanceof RelationshipLink) {
      if (source instanceof JointAggregationLink) {
        this.copyFullAggregationLink(diagram, source, target as JointAggregationLink);
      } else if (source instanceof JointAssociationLink) {
        this.copyFullAssociationLink(diagram, source, target as JointAssociationLink);
      } else if (source instanceof JointCompositionLink) {
        this.copyFullCompositionLink(diagram, source, target as JointCompositionLink);
      } else if (source instanceof JointGenerationLink) {
        this.copyFullGenerationLink(diagram, source, target as JointGenerationLink);
      } else if (source instanceof JointImplementLink) {
        this.copyFullImplementLink(diagram, source, target as JointImplementLink);
      } else if (source instanceof JointCrossLink) {
        this.copyFullCrossLink(diagram, source, target as JointCrossLink);
      } else if (source instanceof JointDependencyAssociationLink) {
        this.copyFullDependencyAssociationLink(diagram, source, target as JointDependencyAssociationLink);
      } else if (source instanceof JointMenuContainLink) {
        this.copyFullMenuContainLink(diagram, source, target as JointMenuContainLink);
      }
    }
  }

  /**
   * 检查是否可以在源图形上创建连线
   * @param linkType 连线类型
   * @param sourceType 源类型（MDAConstant）
   */
  static canCreateLink(linkType: string, sourceType: string): boolean {
    let result = false;
    switch (linkType) {
      case MDAConstant.Link.ADD_AGGREGATION:
      case MDAConstant.Link.ADD_ASSOCIATION:
      case MDAConstant.Link.ADD_COMPOSITION:
      case MDAConstant.Link.ADD_CROSS:
      case MDAConstant.Link.ADD_DEPENDENCY:
      case MDAConstant.Link.ADD_IMPLEMENT:
        result = sourceType === MDAConstant.Type.ADD_ENTITY;
        break;
      case MDAConstant.Link.ADD_GENERALIZATION:
        result = sourceType === MDAConstant.Type.ADD_ENTITY || sourceType === MDAConstant.Type.ADD_INTERFACE;
        break;
      case MDAConstant.Link.ADD_MENUCONTAIN:
        result = sourceType === MDAConstant.Type.ADD_MENUSET;
        break;
      default:
        break;
    }
    return result;
  }

  /**
   * 保存一个完整的组件，如果任意元素发生修改，则保持其完整的结构上传，即：上级元素可能并未发生改变
   * @param diagram 图表
   */
  static async saveComponentAsync(diagram: Diagram, deleteDesignIds: Array<string>): Promise<boolean> {
    // TOOD ：现在是全组件保存，需要修改为只传输变更后的数据，未发生变化的不传输
    return new Promise((resolve, reject) => {
      MDExtendService.SaveComponentAsync(diagram.component, deleteDesignIds)
        .then((res) => {
          if (res) {
            MDExtendService.SaveDiagramAsync(diagram.diagramShape)
              .then((res2) => {
                resolve(res2);
              })
              .catch((error: any) => {
                // TODO : 格式化错误返回
                reject(error);
              });
          } else {
            resolve(false);
          }
        })
        .catch((error: any) => {
          // TODO : 格式化错误返回
          reject(error);
        });
      // const shapePromise = MDExtendService.SaveDiagramAsync(diagram.diagramShape);
      // const mdPromise = MDExtendService.SaveComponentAsync(diagram.component, deleteDesignIds);
      // Promise.all([shapePromise, mdPromise])
      //   .then((results: boolean[]) => {
      //     // console.log(results);
      //     // console.log(results[0]);
      //     // console.log(results[1]);
      //     resolve(results[0] && results[1]);
      //   })
      //   .catch((error: any) => {
      //     // TODO : 格式化错误返回
      //     reject(error);
      //   });
    });
  }

  /**
   * 在图表中创建图形
   * @returns 创建好的图形
   */
  public static createDiagramShape(component: BaseComponent): DiagramShape {
    return MDShapeRepository.createDiagramShape(component);
  }

  /**
   * 创建Product注释图形：新的或者是已有元数据的
   * @param diagram 创建注释图形的图表
   * @param configGroup 要创建图形的注释元数据，如果为 null 则创建新注释
   * @param configGroupShape 注释图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 注释图形
   */
  public static createProductCommentShape(diagram: Diagram, comment: ProductComment, commentShape: NodeShape, startX: number, startY: number): JointCommentShape {
    const component = diagram.component as ProductComponent;
    // 构建元数据图形
    if (commentShape === null) {
      commentShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'ProductComment', true);
    }

    // 构建元数据
    if (comment === null) {
      comment = MDRepository.createProductComment(component, true);
    }
    commentShape.elementId = comment.designId;

    // 构建并返回Joint呈现图形
    const jCommentShape = new JointCommentShape();
    jCommentShape.setMD(commentShape, comment, false);
    return jCommentShape;
  }

  /**
   * 创建产品应用图形：新的或者是已有元数据的
   * @param diagram 创建产品应用图形的图表
   * @param bEEnum 要创建图形的产品应用元数据，如果为 null 则创建新产品应用
   * @param enumShape 产品应用图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 产品应用图形
   */
  public static createProductAPPShape(diagram: Diagram, productAPP: ProductAPP, productAPPShape: NodeShape, startX: number, startY: number): JointProductAPPShape {
    const component = diagram.component as ProductComponent;

    if (productAPPShape === null) {
      productAPPShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'ProductAPP', true);
    }

    if (productAPP === null) {
      productAPP = MDRepository.createProductAPP(component, true);
    }
    productAPPShape.elementId = productAPP.designId;

    const jMenuSetShape = new JointProductAPPShape();
    jMenuSetShape.setMD(productAPPShape, productAPP, false);
    return jMenuSetShape;
  }

  /**
   * 创建APP注释图形：新的或者是已有元数据的
   * @param diagram 创建注释图形的图表
   * @param configGroup 要创建图形的注释元数据，如果为 null 则创建新注释
   * @param configGroupShape 注释图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 注释图形
   */
  public static createAPPCommentShape(diagram: Diagram, comment: APPComment, commentShape: NodeShape, startX: number, startY: number): JointCommentShape {
    const component = diagram.component as APPComponent;
    // 构建元数据图形
    if (commentShape === null) {
      commentShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'APPComment', true);
    }

    // 构建元数据
    if (comment === null) {
      comment = MDRepository.createAPPComment(component, true);
    }
    commentShape.elementId = comment.designId;

    // 构建并返回Joint呈现图形
    const jCommentShape = new JointCommentShape();
    jCommentShape.setMD(commentShape, comment, false);
    return jCommentShape;
  }

  /**
   * 创建菜单集图形：新的或者是已有元数据的
   * @param diagram 创建菜单集图形的图表
   * @param bEEnum 要创建图形的菜单集元数据，如果为 null 则创建新菜单集
   * @param enumShape 菜单集图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 菜单集图形
   */
  public static createMenuSetShape(diagram: Diagram, menuSet: MenuSet, menuSetShape: NodeShape, startX: number, startY: number): JointMenuSetShape {
    const component = diagram.component as APPComponent;

    if (menuSetShape === null) {
      menuSetShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'MenuSet', true);
    }

    if (menuSet === null) {
      menuSet = MDRepository.createMenuSet(component, true);
    }
    menuSetShape.elementId = menuSet.designId;

    const jMenuSetShape = new JointMenuSetShape();
    jMenuSetShape.setMD(menuSetShape, menuSet, false);
    return jMenuSetShape;
  }

  /**
   * 创建配置分组图形：新的或者是已有元数据的
   * @param diagram 创建配置分组图形的图表
   * @param configGroup 要创建图形的配置分组元数据，如果为 null 则创建新配置分组
   * @param configGroupShape 配置分组图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 配置分组图形
   */
  public static createConfigGroupShape(diagram: Diagram, configGroup: ConfigGroup, configGroupShape: NodeShape, startX: number, startY: number): JointConfigGroupShape {
    const component = diagram.component as APPComponent;

    if (configGroupShape === null) {
      configGroupShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'ConfigGroup', true);
    }

    if (configGroup === null) {
      configGroup = MDRepository.createConfigGroup(component, true);
    }
    configGroupShape.elementId = configGroup.designId;

    const jConfigGroupShape = new JointConfigGroupShape();
    jConfigGroupShape.setMD(configGroupShape, configGroup, false);
    return jConfigGroupShape;
  }

  /** 创建菜单主子关系线 */
  public static createMenuContainLink(diagram: Diagram, lineShape: LineShape, menuContain: MenuContain, source: any, target: any) {
    const component = diagram.component as APPComponent;
    if (lineShape === null) {
      lineShape = MDShapeRepository.createLineShape(diagram.diagramShape, 'MenuContain', true);
    }

    if (menuContain === null) {
      let mainMenuSet: MenuSet = null;
      let subMenuSet: MenuSet = null;
      if (source instanceof JointMenuSetShape && source !== null) {
        mainMenuSet = (source as JointMenuSetShape).menuSet;
      }
      if (target instanceof JointMenuSetShape && target !== null) {
        subMenuSet = (target as JointMenuSetShape).menuSet;
      }
      menuContain = MDRepository.createMenuContain(component, mainMenuSet, subMenuSet, true);
    }
    lineShape.relationshipId = menuContain.designId;

    const link = new JointMenuContainLink();
    link.setMD(lineShape, menuContain, false, source, target);
    return link;
  }

  /**
   * 创建BE注释图形：新的或者是已有元数据的
   * @param diagram 创建注释图形的图表
   * @param configGroup 要创建图形的注释元数据，如果为 null 则创建新注释
   * @param configGroupShape 注释图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 注释图形
   */
  public static createBECommentShape(diagram: Diagram, comment: BEComment, commentShape: NodeShape, startX: number, startY: number): JointCommentShape {
    const component = diagram.component as BEComponent;
    // 构建元数据图形
    if (commentShape === null) {
      commentShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'BEComment', true);
    }

    // 构建元数据
    if (comment === null) {
      comment = MDRepository.createBEComment(component, true);
    }
    commentShape.elementId = comment.designId;

    // 构建并返回Joint呈现图形
    const jCommentShape = new JointCommentShape();
    jCommentShape.setMD(commentShape, comment, false);
    return jCommentShape;
  }

  /**
   * 创建实体图形：新的或者是已有元数据的
   * @param diagram 创建实体图形的图表
   * @param entity 要创建图形的实体元数据，如果为 null 则创建新实体
   * @param entityShape 实体图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 实体图形
   */
  public static createEntityShape(diagram: Diagram, entity: BEEntity, entityShape: NodeShape, startX: number, startY: number): JointEntityShape {
    const component = diagram.component as BEComponent;

    if (entityShape === null) {
      entityShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'BEEntity', true);
    }

    if (entity === null) {
      entity = MDRepository.createEntity(component, true);
    }
    entityShape.elementId = entity.designId;

    const jEntityShape = new JointEntityShape();
    jEntityShape.setMD(entityShape, entity, false);
    return jEntityShape;
  }

  /** 创建接口图形 */
  public static createInterfaceShape(diagram: Diagram, bEInterface: BEInterface, interfaceShape: NodeShape, startX: number, startY: number): JointInterfaceShape {
    const component = diagram.component as BEComponent;
    if (interfaceShape === null) {
      interfaceShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'BEInterface', true);
    }

    if (bEInterface === null) {
      bEInterface = MDRepository.createInterface(component, true);
    }
    interfaceShape.elementId = bEInterface.designId;

    const jInterfaceShape = new JointInterfaceShape();
    jInterfaceShape.setMD(interfaceShape, bEInterface, false);
    return jInterfaceShape;
  }

  /**
   * 创建枚举图形：新的或者是已有元数据的
   * @param diagram 创建枚举图形的图表
   * @param bEEnum 要创建图形的枚举元数据，如果为 null 则创建新枚举
   * @param enumShape 枚举图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 枚举图形
   */
  public static createEnumShape(diagram: Diagram, bEEnum: BEEnum, enumShape: NodeShape, startX: number, startY: number): JointEnumShape {
    const component = diagram.component as BEComponent;

    if (enumShape === null) {
      enumShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'BEEnum', true);
    }

    if (bEEnum === null) {
      bEEnum = MDRepository.createEnum(component, true);
    }
    enumShape.elementId = bEEnum.designId;

    const jEnumShape = new JointEnumShape();
    jEnumShape.setMD(enumShape, bEEnum, false);
    return jEnumShape;
  }

  /**
   * 创建商业逻辑图形：新的或者是已有元数据的
   * @param diagram 创建商业逻辑图形的图表
   * @param businessLogic 要创建图形的商业逻辑元数据，如果为 null 则创建新商业逻辑
   * @param businessLogicShape 商业逻辑图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 实体图形
   */
  public static createBusinessLogicShape(diagram: Diagram, businessLogic: BEBusinessLogic, businessLogicShape: NodeShape, startX: number, startY: number): JointBusinessLogicShape {
    const component = diagram.component as BEComponent;

    if (businessLogicShape === null) {
      businessLogicShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'BEBusinessLogic', true);
    }

    if (businessLogic === null) {
      businessLogic = MDRepository.createBusinessLogic(component, true);
    }
    businessLogicShape.elementId = businessLogic.designId;

    const jBusinessLogicShape = new JointBusinessLogicShape();
    jBusinessLogicShape.setMD(businessLogicShape, businessLogic, false);
    return jBusinessLogicShape;
  }

  /**
   * 创建DTO图形：新的或者是已有元数据的
   * @param diagram 创建DTO图形的图表
   * @param dto 要创建图形的DTO元数据，如果为 null 则创建新DTO
   * @param dtoShape DTO图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns DTO图形
   */
  public static createDTOShape(diagram: Diagram, dto: BEDTO, dtoShape: NodeShape, startX: number, startY: number): JointDTOShape {
    const component = diagram.component as BEComponent;

    if (dtoShape === null) {
      dtoShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'BEDTO', true);
    }

    if (dto === null) {
      dto = MDRepository.createDTO(component, true);
    }
    dtoShape.elementId = dto.designId;

    const jDTOShape = new JointDTOShape();
    jDTOShape.setMD(dtoShape, dto, false);
    return jDTOShape;
  }

  /**
   * 创建值对象图形：新的或者是已有元数据的
   * @param diagram 创建值对象图形的图表
   * @param valueObject 要创建图形的值对象元数据，如果为 null 则创建新值对象
   * @param valueObjectShape 值对象图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 值对象图形
   */
  public static createValueObjectShape(diagram: Diagram, valueObject: BEValueObject, valueObjectShape: NodeShape, startX: number, startY: number): JointValueObjectShape {
    const component = diagram.component as BEComponent;

    if (valueObjectShape === null) {
      valueObjectShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'BEValueObject', true);
    }

    if (valueObject === null) {
      valueObject = MDRepository.createValueObject(component, true);
    }
    valueObjectShape.elementId = valueObject.designId;

    const jValueObjectShape = new JointValueObjectShape();
    jValueObjectShape.setMD(valueObjectShape, valueObject, false);
    return jValueObjectShape;
  }

  /**
   * 创建服务图形：新的或者是已有元数据的
   * @param diagram 创建服务图形的图表
   * @param service 要创建图形的服务元数据，如果为 null 则创建新服务
   * @param serviceShape 服务图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 服务图形
   */
  public static createServiceShape(diagram: Diagram, service: BEService, serviceShape: NodeShape, startX: number, startY: number): JointServiceShape {
    const component = diagram.component as BEComponent;

    if (serviceShape === null) {
      serviceShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'BEService', true);
    }

    if (service === null) {
      service = MDRepository.createService(component, true);
    }
    serviceShape.elementId = service.designId;

    const jServiceShape = new JointServiceShape();
    jServiceShape.setMD(serviceShape, service, false);
    return jServiceShape;
  }

  /**
   * 创建外部服务图形：新的或者是已有元数据的
   * @param diagram 创建外部服务图形的图表
   * @param configGroup 要创建图形的外部服务元数据，如果为 null 则创建新外部服务
   * @param configGroupShape外部服务图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 外部服务图形
   */
  public static createExternalServiceShape(diagram: Diagram, externalService: BEExternalService, externalServiceShape: NodeShape, startX: number, startY: number): JointExternalServiceShape {
    const component = diagram.component as BEComponent;

    if (externalServiceShape === null) {
      externalServiceShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'BEExternalService', true);
    }

    if (externalService === null) {
      externalService = MDRepository.createExternalService(component, true);
    }
    externalServiceShape.elementId = externalService.designId;

    const jExternalServiceShape = new JointExternalServiceShape();
    jExternalServiceShape.setMD(externalServiceShape, externalService, false);
    return jExternalServiceShape;
  }

  /**
   * 创建分布式事务图形：新的或者是已有元数据的
   * @param diagram 创建分布式事务图形的图表
   * @param service 要创建图形的分布式事务元数据，如果为 null 则创建新分布式事务
   * @param serviceShape 分布式事务图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 分布式事务图形
   */
  public static createDistributedTransactionShape(diagram: Diagram, distributedTransaction: BEDistributedTransaction, distributedTransactionShape: NodeShape, startX: number, startY: number): JointDistributedTransactionShape {
    const component = diagram.component as BEComponent;

    if (distributedTransactionShape === null) {
      distributedTransactionShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'BEDistributedTransaction', true);
    }

    if (distributedTransaction === null) {
      distributedTransaction = MDRepository.createDistributedTransaction(component, true);
    }
    distributedTransactionShape.elementId = distributedTransaction.designId;

    const jDistributedTransactionShape = new JointDistributedTransactionShape();
    jDistributedTransactionShape.setMD(distributedTransactionShape, distributedTransaction, false);
    return jDistributedTransactionShape;
  }

  /**
   * 创建常量图形：新的或者是已有元数据的
   * @param diagram 创建常量图形的图表
   * @param constant 要创建图形的常量元数据，如果为 null 则创建新常量
   * @param constantShape 常量图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 常量图形
   */
  public static createConstantShape(diagram: Diagram, constant: BEConstant, constantShape: NodeShape, startX: number, startY: number): JointConstantShape {
    const component = diagram.component as BEComponent;

    if (constantShape === null) {
      constantShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'BEConstant', true);
    }

    if (constant === null) {
      constant = MDRepository.createConstant(component, true);
    }
    constantShape.elementId = constant.designId;

    const jConstantShape = new JointConstantShape();
    jConstantShape.setMD(constantShape, constant, false);
    return jConstantShape;
  }

  /**
   * 创建引用实体图形：新的或者是已有元数据的
   * @param diagram 创建引用实体图形的图表
   * @param referenceEntity 要创建图形的引用实体元数据，如果为 null 则创建新引用实体
   * @param referenceEntityShape 引用实体图形，如果为空则创建空的节点图形
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 引用实体图形
   */
  public static createReferenceEntityShape(diagram: Diagram, referenceEntity: BEReferenceEntity, referenceEntityShape: NodeShape, startX: number, startY: number): JointReferenceEntityShape {
    const component = diagram.component as BEComponent;

    if (referenceEntityShape === null) {
      referenceEntityShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'BEReferenceEntity', true);
    }

    if (referenceEntity === null) {
      referenceEntity = MDRepository.createReferenceEntity(component, true);
    }
    referenceEntityShape.elementId = referenceEntity.designId;

    const jReferenceEntityShape = new JointReferenceEntityShape();
    jReferenceEntityShape.setMD(referenceEntityShape, referenceEntity, false);
    return jReferenceEntityShape;
  }

  /**
   * 创建实体方法图形：新的或者是已有元数据的（方法图形是一种动态附加图形，不同于普通的节点图形）
   * 不加入Diagram，仅内存图形
   * @param diagram 创建方法图形的图表
   * @param method 要创建图形的方法元数据，如果为 null 则创建新方法
   * @param startX 图形的左上角 X 坐标
   * @param startY 图形的左上角 Y 坐标
   * @returns 方法图形
   */
  public static createMethodShape(diagram: Diagram, method: EntityMethod | InterfaceMethod | ValueObjectMethod, startX: number, startY: number): JointMethodShape {
    const methodShape = MDShapeRepository.createNodeShape(diagram.diagramShape, startX, startY, 'Method', false);
    methodShape.elementId = method.designId;

    const jConstantShape = new JointMethodShape();
    jConstantShape.setMD(methodShape, method, false);
    return jConstantShape;
  }

  /** 创建继承线 */
  public static createGenerationLink(diagram: Diagram, lineShape: LineShape, entityGeneration: EntityGeneration, interfaceGeneration: InterfaceGeneration, source: any, target: any) {
    const component = diagram.component as BEComponent;
    if (lineShape === null) {
      if (source instanceof JointEntityShape) {
        lineShape = MDShapeRepository.createLineShape(diagram.diagramShape, 'EntityGeneration', true);
        if (entityGeneration === null) {
          let sourceEntity: BEEntity = null;
          let targetEntity: BEEntity = null;
          if (source instanceof JointEntityShape && source !== null) {
            sourceEntity = (source as JointEntityShape).entity;
          }
          if (target instanceof JointEntityShape && target !== null) {
            targetEntity = (target as JointEntityShape).entity;
          }
          entityGeneration = MDRepository.createEntityGeneration(component, targetEntity, sourceEntity, true);
        }
        lineShape.relationshipId = entityGeneration.designId;
      } else if (source instanceof JointInterfaceShape) {
        lineShape = MDShapeRepository.createLineShape(diagram.diagramShape, 'InterfaceGeneration', true);
        if (interfaceGeneration === null) {
          let sourceInterface: BEInterface = null;
          let targetInterface: BEInterface = null;
          if (source instanceof JointInterfaceShape && source !== null) {
            sourceInterface = (source as JointInterfaceShape).interface;
          }
          if (target instanceof JointInterfaceShape && target !== null) {
            targetInterface = (target as JointInterfaceShape).interface;
          }
          interfaceGeneration = MDRepository.createInterfaceGeneration(component, targetInterface, sourceInterface, true);
        }
        lineShape.relationshipId = interfaceGeneration.designId;
      }
      // diagram.diagramShape.lineShapes.push(lineShape);
    }
    const generation = entityGeneration === null ? interfaceGeneration : entityGeneration;
    const link = new JointGenerationLink();
    link.setMD(lineShape, generation, false, source, target);
    return link;
  }

  /** 创建实现接口的线 */
  public static createImplementLink(diagram: Diagram, lineShape: LineShape, implement: Implement, source: any, target: any): JointImplementLink {
    const component = diagram.component as BEComponent;
    if (lineShape === null) {
      lineShape = MDShapeRepository.createLineShape(diagram.diagramShape, 'implement', true);
    }
    if (implement === null) {
      let sourceEntity: BEEntity = null;
      let targetInterface: BEInterface = null;
      if (source instanceof JointEntityShape && source !== null) {
        sourceEntity = (source as JointEntityShape).entity;
      }
      if (target instanceof JointInterfaceShape && target !== null) {
        targetInterface = (target as JointInterfaceShape).interface;
      }
      implement = MDRepository.createImplement(component, sourceEntity, targetInterface, true);
    }
    lineShape.relationshipId = implement.designId;

    const link = new JointImplementLink();
    link.setMD(lineShape, implement, false, source, target);
    return link;
  }

  /** 创建关联关系的线 */
  public static createAssociationLink(diagram: Diagram, lineShape: LineShape, association: Association, source: any, target: any): JointAssociationLink {
    const component = diagram.component as BEComponent;
    if (lineShape === null) {
      lineShape = MDShapeRepository.createLineShape(diagram.diagramShape, 'association', true);
    }
    if (association === null) {
      let sourceEntity: BEEntity = null;
      let targetEntity: BEEntity = null;
      if (source instanceof JointEntityShape && source !== null) {
        sourceEntity = (source as JointEntityShape).entity;
      }
      if (target instanceof JointEntityShape && target !== null) {
        targetEntity = (target as JointEntityShape).entity;
      }
      association = MDRepository.createAssociation(component, sourceEntity, targetEntity, true);
    }
    lineShape.relationshipId = association.designId;

    const link = new JointAssociationLink();
    link.setMD(lineShape, association, false, source, target);
    return link;
  }

  /** 创建依赖关联关系的线 */
  public static createDependencyLink(diagram: Diagram, lineShape: LineShape, dependency: DependencyAssociation, source: any, target: any): JointDependencyAssociationLink {
    const component = diagram.component as BEComponent;
    if (lineShape === null) {
      lineShape = MDShapeRepository.createLineShape(diagram.diagramShape, 'dependency', true);
    }
    if (dependency === null) {
      let sourceEntity: BEEntity = null;
      let targetEntity: BEEntity = null;
      if (source instanceof JointEntityShape && source !== null) {
        sourceEntity = (source as JointEntityShape).entity;
      }
      if (target instanceof JointEntityShape && target !== null) {
        targetEntity = (target as JointEntityShape).entity;
      }
      dependency = MDRepository.createDependencyAssociation(component, sourceEntity, targetEntity, true);
    }
    lineShape.relationshipId = dependency.designId;
    const link = new JointDependencyAssociationLink();
    link.setMD(lineShape, dependency, false, source, target);
    return link;
  }

  /** 创建组合关系的线 */
  public static createCompositionLink(diagram: Diagram, lineShape: LineShape, composition: Composition, source: any, target: any): JointCompositionLink {
    const component = diagram.component as BEComponent;
    if (lineShape === null) {
      lineShape = MDShapeRepository.createLineShape(diagram.diagramShape, 'composition', true);
    }
    if (composition === null) {
      let sourceEntity: BEEntity = null;
      let targetEntity: BEEntity = null;
      if (source instanceof JointEntityShape && source !== null) {
        sourceEntity = (source as JointEntityShape).entity;
      }
      if (target instanceof JointEntityShape && target !== null) {
        targetEntity = (target as JointEntityShape).entity;
      }
      composition = MDRepository.createComposition(component, sourceEntity, targetEntity, true);
    }
    lineShape.relationshipId = composition.designId;
    const link = new JointCompositionLink();
    link.setMD(lineShape, composition, false, source, target);
    return link;
  }

  /** 创建聚合关系的线 */
  public static createAggregationLink(diagram: Diagram, lineShape: LineShape, aggregation: Aggregation, source: any, target: any): JointAggregationLink {
    const component = diagram.component as BEComponent;
    if (lineShape === null) {
      lineShape = MDShapeRepository.createLineShape(diagram.diagramShape, 'aggregation', true);
    }
    if (aggregation === null) {
      let sourceEntity: BEEntity = null;
      let targetEntity: BEEntity = null;
      if (source instanceof JointEntityShape && source !== null) {
        sourceEntity = (source as JointEntityShape).entity;
      }
      if (target instanceof JointEntityShape && target !== null) {
        targetEntity = (target as JointEntityShape).entity;
      }
      aggregation = MDRepository.createAggregation(component, sourceEntity, targetEntity, true);
    }
    lineShape.relationshipId = aggregation.designId;
    const link = new JointAggregationLink();
    link.setMD(lineShape, aggregation, false, source, target);
    return link;
  }

  /** 创建交叉关系的线 */
  public static createCrossLink(diagram: Diagram, lineShape: LineShape, cross: CrossAssociation, source: any, target: any): JointCrossLink {
    const component = diagram.component as BEComponent;
    if (lineShape === null) {
      lineShape = MDShapeRepository.createLineShape(diagram.diagramShape, 'cross', true);
    }
    if (cross === null) {
      let sourceEntity: BEEntity = null;
      let targetEntity: BEEntity = null;
      if (source instanceof JointEntityShape && source !== null) {
        sourceEntity = (source as JointEntityShape).entity;
      }
      if (target instanceof JointEntityShape && target !== null) {
        targetEntity = (target as JointEntityShape).entity;
      }
      cross = MDRepository.createCrossAssociation(component, sourceEntity, targetEntity, true);
    }
    lineShape.relationshipId = cross.designId;
    const link = new JointCrossLink();
    link.setMD(lineShape, cross, false, source, target);
    return link;
  }

  /**
   * 将源同步到目标
   * @param diagram 图表
   * @param source 源
   * @param target 目标
   */
  public static copyFullEntityShape(diagram: Diagram, source: JointEntityShape, target: JointEntityShape) {
    if (!target) {
      target = JointShapeRepository.createEntityShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    MDExtendService.copyMDArray(source.entity.attributes, target.entity.attributes, true, BEAttribute);
    MDExtendService.copyMDArray(source.entity.methods, target.entity.methods, true, EntityMethod);
    source.entity.methods.forEach(method => {
      if (method.parameters.length > 0) {
        const targetMethod = target.entity.methods.find(item => item.designId === method.designId);
        MDExtendService.copyMDArray(method.parameters, targetMethod.parameters, true, MethodParameter);
      }
    });
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.setMD(target.shape(), target.element() as BEEntity, true); // 保证图形的数据模型正确
    target.refresh();
  }

  public static copyFullCommentShape(diagram: Diagram, source: JointCommentShape, target: JointCommentShape) {
    if (!target) {
      if (source.comment instanceof BEComment) {
        target = JointShapeRepository.createBECommentShape(diagram, null, null, 0, 0);
      } else if (source.comment instanceof APPComment) {
        target = JointShapeRepository.createAPPCommentShape(diagram, null, null, 0, 0);
      } else if (source.comment instanceof ProductComment) {
        target = JointShapeRepository.createProductCommentShape(diagram, null, null, 0, 0);
      }
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.refresh();
  }

  public static copyFullBusinessLogicShape(diagram: Diagram, source: JointBusinessLogicShape, target: JointBusinessLogicShape) {
    if (!target) {
      target = JointShapeRepository.createBusinessLogicShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    MDExtendService.copyMDArray(source.businessLogic.parameters, target.businessLogic.parameters, true, BLParameter);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.setMD(target.shape(), target.element() as BEBusinessLogic, true); // 保证图形的数据模型正确
    target.refresh();
  }

  public static copyFullConstantShape(diagram: Diagram, source: JointConstantShape, target: JointConstantShape) {
    if (!target) {
      target = JointShapeRepository.createConstantShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    MDExtendService.copyMDArray(source.constant.items, target.constant.items, true, ConstantItem);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.setMD(target.shape(), target.element() as BEConstant, true); // 保证图形的数据模型正确
    target.refresh();
  }

  public static copyFullReferenceEntityShape(diagram: Diagram, source: JointReferenceEntityShape, target: JointReferenceEntityShape) {
    if (!target) {
      target = JointShapeRepository.createReferenceEntityShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.refresh();
  }

  public static copyFullDistributedTransactionShape(diagram: Diagram, source: JointDistributedTransactionShape, target: JointDistributedTransactionShape) {
    if (!target) {
      target = JointShapeRepository.createDistributedTransactionShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    MDExtendService.copyMDArray(source.distributedTransaction.attributes, target.distributedTransaction.attributes, true, DTAttribute);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.setMD(target.shape(), target.element() as BEDistributedTransaction, true); // 保证图形的数据模型正确
    target.refresh();
  }

  public static copyFullDTOShape(diagram: Diagram, source: JointDTOShape, target: JointDTOShape) {
    if (!target) {
      target = JointShapeRepository.createDTOShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    MDExtendService.copyMDArray(source.dto.attributes, target.dto.attributes, true, DTOAttribute);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.setMD(target.shape(), target.element() as BEDTO, true); // 保证图形的数据模型正确
    target.refresh();
  }

  public static copyFullEnumShape(diagram: Diagram, source: JointEnumShape, target: JointEnumShape) {
    if (!target) {
      target = JointShapeRepository.createEnumShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    MDExtendService.copyMDArray(source.enum.enumItems, target.enum.enumItems, true, EnumItem);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.setMD(target.shape(), target.element() as BEEnum, true); // 保证图形的数据模型正确
    target.refresh();
  }

  public static copyFullExternalServiceShape(diagram: Diagram, source: JointExternalServiceShape, target: JointExternalServiceShape) {
    if (!target) {
      target = JointShapeRepository.createExternalServiceShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    MDExtendService.copyMDArray(source.externalService.parameters, target.externalService.parameters, true, ESParameter);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.setMD(target.shape(), target.element() as BEExternalService, true); // 保证图形的数据模型正确
    target.refresh();
  }

  public static copyFullInterfaceShape(diagram: Diagram, source: JointInterfaceShape, target: JointInterfaceShape) {
    if (!target) {
      target = JointShapeRepository.createInterfaceShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    MDExtendService.copyMDArray(source.interface.attributes, target.interface.attributes, true, InterfaceAttribute);
    MDExtendService.copyMDArray(source.interface.methods, target.interface.methods, true, InterfaceMethod);
    source.interface.methods.forEach(method => {
      if (method.parameters.length > 0) {
        const targetMethod = target.interface.methods.find(item => item.designId === method.designId);
        MDExtendService.copyMDArray(method.parameters, targetMethod.parameters, true, MethodParameter);
      }
    });
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.setMD(target.shape(), target.element() as BEInterface, true); // 保证图形的数据模型正确
    target.refresh();
  }

  public static copyFullServiceShape(diagram: Diagram, source: JointServiceShape, target: JointServiceShape) {
    if (!target) {
      target = JointShapeRepository.createServiceShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    MDExtendService.copyMDArray(source.service.serviceActions, target.service.serviceActions, true, BEServiceAction);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.setMD(target.shape(), target.element() as BEService, true); // 保证图形的数据模型正确
    target.refresh();
  }

  public static copyFullValueObjectShape(diagram: Diagram, source: JointValueObjectShape, target: JointValueObjectShape) {
    if (!target) {
      target = JointShapeRepository.createValueObjectShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    MDExtendService.copyMDArray(source.valueObject.attributes, target.valueObject.attributes, true, ValueObjectAttribute);
    MDExtendService.copyMDArray(source.valueObject.methods, target.valueObject.methods, true, ValueObjectMethod);
    source.valueObject.methods.forEach(method => {
      if (method.parameters.length > 0) {
        const targetMethod = target.valueObject.methods.find(item => item.designId === method.designId);
        MDExtendService.copyMDArray(method.parameters, targetMethod.parameters, true, MethodParameter);
      }
    });
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.setMD(target.shape(), target.element() as BEValueObject, true); // 保证图形的数据模型正确
    target.refresh();
  }

  public static copyFullConfigGroupShape(diagram: Diagram, source: JointConfigGroupShape, target: JointConfigGroupShape) {
    if (!target) {
      target = JointShapeRepository.createConfigGroupShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    MDExtendService.copyMDArray(source.configGroup.configItems, target.configGroup.configItems, true, ConfigItem);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.setMD(target.shape(), target.element() as ConfigGroup, true); // 保证图形的数据模型正确
    target.refresh();
  }

  public static copyFullMenuSetShape(diagram: Diagram, source: JointMenuSetShape, target: JointMenuSetShape) {
    if (!target) {
      target = JointShapeRepository.createMenuSetShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    MDExtendService.copyMDArray(source.menuSet.menuItems, target.menuSet.menuItems, true, MenuItem);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.setMD(target.shape(), target.element() as MenuSet, true); // 保证图形的数据模型正确
    target.refresh();
  }

  public static copyFullProductAPPShape(diagram: Diagram, source: JointProductAPPShape, target: JointProductAPPShape) {
    if (!target) {
      target = JointShapeRepository.createProductAPPShape(diagram, null, null, 0, 0);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.refresh();
  }

  public static copyFullAggregationLink(diagram: Diagram, source: JointAggregationLink, target: JointAggregationLink) {
    if (!target) {
      target = JointShapeRepository.createAggregationLink(diagram, null, null, source.source, source.target);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.refresh();
  }

  public static copyFullAssociationLink(diagram: Diagram, source: JointAssociationLink, target: JointAssociationLink) {
    if (!target) {
      target = JointShapeRepository.createAssociationLink(diagram, null, null, source.source, source.target);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.refresh();
  }

  public static copyFullCompositionLink(diagram: Diagram, source: JointCompositionLink, target: JointCompositionLink) {
    if (!target) {
      target = JointShapeRepository.createCompositionLink(diagram, null, null, source.source, source.target);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.refresh();
  }

  public static copyFullCrossLink(diagram: Diagram, source: JointCrossLink, target: JointCrossLink) {
    if (!target) {
      target = JointShapeRepository.createCrossLink(diagram, null, null, source.source, source.target);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.refresh();
  }

  public static copyFullDependencyAssociationLink(diagram: Diagram, source: JointDependencyAssociationLink, target: JointDependencyAssociationLink) {
    if (!target) {
      target = JointShapeRepository.createDependencyLink(diagram, null, null, source.source, source.target);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.refresh();
  }

  public static copyFullGenerationLink(diagram: Diagram, source: JointGenerationLink, target: JointGenerationLink) {
    if (!target) {
      target = JointShapeRepository.createGenerationLink(diagram, null, null, null, source.source, source.target);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.refresh();
  }

  public static copyFullImplementLink(diagram: Diagram, source: JointImplementLink, target: JointImplementLink) {
    if (!target) {
      target = JointShapeRepository.createImplementLink(diagram, null, null, source.source, source.target);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.refresh();
  }

  public static copyFullMenuContainLink(diagram: Diagram, source: JointMenuContainLink, target: JointMenuContainLink) {
    if (!target) {
      target = JointShapeRepository.createMenuContainLink(diagram, null, null, source.source, source.target);
      diagram.cells.push(target);
    }
    target.element().copyFrom(source.element(), true);
    target.shape().copyFrom(source.shape(), true); // 将图形元数据同步到内存元数据
    target.refresh();
  }
}
